import { render, staticRenderFns } from "./IdeaResult.vue?vue&type=template&id=205ccc62&scoped=true&"
import script from "./IdeaResult.vue?vue&type=script&lang=js&"
export * from "./IdeaResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205ccc62",
  null
  
)

export default component.exports